import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextBoxEditorTitleProps = Pick<
  TypographyProps,
  'label' | 'color' | 'uppercase' | 'fontWeight' | 'ellipsis'
>;

export const TextBoxEditorTitle = ({
  label,
  color = 'text-ds-natural',
  uppercase,
  fontWeight = 'font-ds-normal',
  ellipsis,
}: TextBoxEditorTitleProps) => (
  <Typography
    uppercase={uppercase}
    color={color}
    label={label}
    tagName="span"
    fontSize="text-ds-100"
    lineHeight="leading-ds-200"
    fontWeight={fontWeight}
    letterSpacing="tracking-ds-wide"
    ellipsis={ellipsis}
  />
);
